module.exports = "pegasus_template/assets/themelp1/app/103.png";